import React from 'react';
import { DecisionQpcInSnippet } from '../../decision.types';
import { getLawCardQPCDecisions } from '../../../legislation/legislation.api';

type Props = {
  articleId: string;
  children: (
    decisions: Array<DecisionQpcInSnippet>,
  ) => React.ReactElement | null;
};

type State = {
  decisions: Array<DecisionQpcInSnippet>;
};

export class DecisionQpcFetcher extends React.Component<Props, State> {
  state: State = { decisions: [] };

  componentDidMount() {
    this.loadData(this.props.articleId);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.articleId !== this.props.articleId) {
      this.loadData(this.props.articleId);
    }
  }

  loadData = async (articleId: string) => {
    const decisions = (await getLawCardQPCDecisions(articleId)).map(
      decision => ({
        ...decision,
        url: decision.referenceUrl,
      }),
    );
    this.setState({ decisions });
  };

  render() {
    const { decisions } = this.state;
    return this.props.children(decisions);
  }
}
